var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useEffect, useState, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import ScrollView from '@hfe/max-scrollview';
// import LText from '@max/leez-text';
import Card from './Card';
import Icon from '@max/leez-icon';
import './index.scss';
import Image from '@hfe/max-image';
import fetchData from './api';
import { LOAD_MORE_TYPE } from './types';
import { DYNAMIC_LIST_SCENE_TOKEN, LX_CONFIG, SHOW_TYPE_ENUM } from './constants';
import Sensor from '@max/mbc-sensor';
import Skeleton from './Skeleton';
import LoadingView from '@max/leez-loading-view';
import { useUserInfo } from './common-api/use-user';
import { useLocation } from './hooks/useLocation';
import { getLBSInfo } from '@nibfe/mkt-lbs-api';
import { getCityInfo } from '@max/meituan-uni-city';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { onGoFilter } from './utils';
const DEV_DATA = {
    batchId: '1794167826',
    poiTagId: 670909,
    uuid: 237
};
const DEFAULT_CITY_ID = 1;
const PhxPoiList = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { userInfo } = useUserInfo();
    const { location, locationDone } = useLocation(DYNAMIC_LIST_SCENE_TOKEN);
    const { tagIds, sortType, pageSize = 10, showType, 
    // showMoreJumpLink,
    loadMoreType = LOAD_MORE_TYPE.LINK, 
    //后端不支持分页，暂时固定为link
    fullRoomBase, marginTop, marginBottom, noDataText, noDataTextColor, noDataBackgroundColor, noDataImg, 
    // noDataJumpLink,
    clickBizLine, loadMoreForceLogin, wakeupSource = 'waitou_default', defaultPost = true // 是否采用默认城市初始化请求
     } = props;
    const userId = useRef('');
    const userUuid = useRef('');
    const offset = useRef(0);
    // const { uuid, poiTagId } = poiDataInfo ?? {};
    const tagIdArr = tagIds === null || tagIds === void 0 ? void 0 : tagIds.split(',').reduce((acc, item) => {
        const num = Number(item);
        if (!isNaN(num)) {
            acc.push(num);
        }
        return acc;
    }, []);
    const ctx = useMonitorEngineContext();
    // const ctx = useContext<BusinessCommonEngineInject>(global._EngineGlobalContext);
    // 优先走跳链上拼接的cityId
    // const cityId = useRef(ctx?._runtimeInfo?.queryParams?.cityId ?? DEFAULT_CITY_ID);
    const chosenCityId = useRef((_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.cityId) !== null && _c !== void 0 ? _c : DEFAULT_CITY_ID);
    const { userId: comUserId, token: comToken } = ((_d = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _d === void 0 ? void 0 : _d.commonParams) || {}; // NOTE:建议用户信息和城市id都从commonParams中获取
    const { _LXReport, _moduleId } = ctx;
    // const [phxList, setPhxList] = useState([]);
    const phxList = useRef([]);
    const [displayList, setDisplayList] = useState([]);
    const [noMore, setNoMore] = useState(false);
    const [showSkeleton, setShowSkeleton] = useState(false);
    const [showNoDataView, setShowNoDataView] = useState(false);
    const [showLoading, setShowLoading] = useState(false);
    const isCityInitializedDefault = defaultPost; // 如果以默认城市初始化请求，则不需要等待cityChange事件
    const isCityInitialized = useRef(isCityInitializedDefault);
    const hotelchannel = (_f = (_e = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _e === void 0 ? void 0 : _e.queryParams) === null || _f === void 0 ? void 0 : _f.hotelchannel;
    const getFrontListVo = (backendProductList) => {
        const { buyButtonText, headIcon, headIconImg, headIconText, headIconTextColor, headIconBackgroundColor, scoreInfoSwitch, distanceInfoSwitch, salesInfoSwitch, bookInfoSwitch, priceColor, buyButtonTextColor, buyButtonBackgroundColor } = props;
        const result = [];
        if (!(backendProductList && (backendProductList === null || backendProductList === void 0 ? void 0 : backendProductList.length))) {
            return [];
        }
        backendProductList.forEach(backendProduct => {
            var _a;
            const { productId, productIdStr, headImage, title, positionInfo, priceModel, status, rating, userReview, score, salesCount, extModel, bookInfo } = backendProduct;
            const phxListCard = {
                productId,
                productIdStr,
                headImage: {
                    value: headImage
                },
                title,
                positionInfo: (_a = positionInfo === null || positionInfo === void 0 ? void 0 : positionInfo[0]) !== null && _a !== void 0 ? _a : '',
                price: priceModel,
                status,
                buyButtonText,
                salesCount,
                score,
                rating,
                userReview: userReview[0] ? `“${userReview[0]}”` : '',
                headIcon,
                headIconImg,
                headIconText,
                headIconTextColor,
                headIconBackgroundColor,
                extModel,
                bookInfo,
                scoreInfoSwitch,
                distanceInfoSwitch,
                salesInfoSwitch,
                bookInfoSwitch,
                priceColor,
                buyButtonTextColor,
                buyButtonBackgroundColor
            };
            result.push(phxListCard);
        });
        return result;
    };
    const setDisplayPoiList = (isRefresh = false) => {
        const finalList = phxList.current;
        const startIndex = offset.current;
        const endIndex = startIndex + pageSize;
        // 1. 先获取要展示的数据
        const finalDisPlayList = finalList.slice(startIndex, Math.min(endIndex, finalList.length));
        // 2. 如果有数据才更新
        if (finalDisPlayList.length > 0) {
            if (isRefresh) {
                setDisplayList(finalDisPlayList);
            }
            else {
                setDisplayList(prev => [...prev, ...finalDisPlayList]);
            }
            offset.current = endIndex;
        }
        // 3. 判断是否还有更多数据
        const isNoMore = finalList.length <= endIndex;
        setNoMore(isNoMore);
    };
    const getPoiList = (refresh = false) => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j, _k, _l, _m, _o, _p, _q;
        console.log('getPoiList: ');
        //const { dateBegin, dateEnd } = getDate();
        const reqData = {
            uuid: userUuid.current || '',
            userId: comUserId,
            dynamicTagId: tagIdArr,
            fullPoiFormat: fullRoomBase,
            // poiTagUuid: uuid,
            // offset: offset.current,
            // limit: pageSize,
            sort: sortType,
            sortWithPrivilegePoi: props === null || props === void 0 ? void 0 : props.sortWithPrivilegePoi,
            // hotelChannel: ctx?._runtimeInfo?.queryParams?.hotelchannel,
            userLongitude: location === null || location === void 0 ? void 0 : location.lng,
            userLatitude: location === null || location === void 0 ? void 0 : location.lat,
            chosenCityId: chosenCityId.current,
            token: comToken,
            locateCityId: DEFAULT_CITY_ID //本地默认
        };
        try {
            //本地跨越获取不到
            const cityInfo = yield getCityInfo();
            reqData.locateCityId = (cityInfo === null || cityInfo === void 0 ? void 0 : cityInfo.id) || DEFAULT_CITY_ID;
        }
        catch (e) {
            console.log('getCityInfo error: ', e);
        }
        // 预览态，需要注意
        if (window === null || window === void 0 ? void 0 : window.inEditor) {
            reqData.previewId = '1';
        }
        try {
            if (!refresh) {
                setShowLoading(true);
            }
            setShowNoDataView(false);
            const params = {
            // userId: userId.current,
            // userid: userId.current,
            // utm_medium: systemType === SystemType.android ? 'android' : 'iphone',
            // uuid: userUuid.current,
            // utm_content: userUuid.current,
            };
            // console.log('params before fetchData: ', ctx?._runtimeInfo, params);
            console.log('minsu reqData before fetchData: ', reqData);
            const { productInfoList = [] } = yield fetchData(reqData, params, wakeupSource, () => { var _a, _b; return (_b = (_a = ctx._raptorReport).monitorReportNetworkSuccess) === null || _b === void 0 ? void 0 : _b.call(_a); }, () => { var _a, _b; return (_b = (_a = ctx._raptorReport).monitorReportNetworkFailed) === null || _b === void 0 ? void 0 : _b.call(_a); });
            if (Array.isArray(productInfoList)) {
                // 业务成功了，我拿到了想要的数据
                (_j = (_h = ctx._raptorReport).monitorReportBizSuccess) === null || _j === void 0 ? void 0 : _j.call(_h);
                if (productInfoList.length) {
                    // 货架没有空搜
                    (_l = (_k = ctx._raptorReport).monitorReportShelfNormal) === null || _l === void 0 ? void 0 : _l.call(_k);
                }
                else {
                    // 货架空搜
                    (_o = (_m = ctx._raptorReport).monitorReportShelfEmpty) === null || _o === void 0 ? void 0 : _o.call(_m, {
                        city_id: reqData.locateCityId
                    });
                }
            }
            else {
                // 业务失败了
                (_q = (_p = ctx._raptorReport).monitorReportBizFailed) === null || _q === void 0 ? void 0 : _q.call(_p, {
                    city_id: reqData.locateCityId
                });
            }
            const frontList = getFrontListVo(productInfoList);
            // 初始化就无货时，认为该城市无货，走兜底逻辑
            if ((frontList === null || frontList === void 0 ? void 0 : frontList.length) === 0) {
                setShowNoDataView(true);
            }
            phxList.current = frontList;
            setDisplayPoiList(refresh);
        }
        catch (error) {
            ctx._uiInteractionAPI.toast.show({
                content: '活动太火爆啦～'
            });
        }
        setShowSkeleton(false);
        setShowLoading(false);
    });
    const init = () => {
        // if (!poiTagId || !uuid) {
        if (!(tagIdArr === null || tagIdArr === void 0 ? void 0 : tagIdArr.length)) {
            return;
        }
        offset.current = 0;
        setShowSkeleton(true);
        phxList.current = [];
        getPoiList(true);
    };
    // const loadMore = async () => {
    //   if ((!userId.current || !userUuid.current) && !loadMoreForceLogin) {
    //     console.log("分支1");
    //     console.log('userUuid.current: ', userUuid.current);
    //     console.log('userId.current: ', userId.current);
    //     const res = await login();
    //     if (res?.userId) {
    //       const userInfoAfterLogin = await getUserInfo();
    //       console.log('userInfoAfterLogin: ', userInfoAfterLogin);
    //       const { userId: originalUserId, uuid: user_uuid } = userInfoAfterLogin ?? {};
    //       if (originalUserId) {
    //         userId.current = originalUserId;
    //         userUuid.current = user_uuid;
    //         init();
    //       }
    //     } else {
    //       setTimeout(() => {
    //         navigateBack({
    //           _web: {
    //             miniProgramNative: true, //说明：此参数只在web端生效。1）如果在小程序/点评&美团APP中，为ture的话会调用native的方法，也就是直接关闭这个页面，为fase或不传在当前webview中返回。
    //           },
    //         });
    //       }, 500);
    //     }
    //   } else {
    //     if (loadMoreType === LOAD_MORE_TYPE.LINK) {
    //       console.log("分支2-1");
    //      onGoFilter({cityId:chosenCityId.current,clickBizLine,hotelchannel});
    //     } else {
    //       console.log("分支2-2");
    //       getPoiList();
    //     }
    //   }
    // };
    const loadMore = (moreType) => {
        const finalLoadMoreType = moreType !== null && moreType !== void 0 ? moreType : loadMoreType;
        if (finalLoadMoreType === LOAD_MORE_TYPE.LINK) {
            onGoFilter({
                cityId: chosenCityId.current,
                clickBizLine,
                hotelchannel
            });
            return;
        }
        setDisplayPoiList();
    };
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b;
            if (userInfo.done && locationDone) {
                const { userId: originalUserId, uuid: user_uuid } = userInfo !== null && userInfo !== void 0 ? userInfo : {};
                console.log('userInfo=====: ', userInfo);
                if (originalUserId) {
                    userId.current = originalUserId;
                    userUuid.current = user_uuid;
                }
                if (defaultPost) {
                    // 如果需要采用首页城市
                    try {
                        let locationInfo = yield getLBSInfo({
                            needLocation: true,
                            sceneToken: 'dd-9cbc1c31cfbf2bba'
                        });
                        if (locationInfo) {
                            chosenCityId.current = locationInfo.homeSelectedCity || 1;
                        }
                    }
                    catch (error) {
                        console.log('phx获取首页选择城市失败');
                    }
                }
                if (isCityInitialized.current) {
                    yield init();
                }
                if (props.isAllCityShow) {
                    chosenCityId.current = 0;
                }
                console.log('cube_router_url', decodeURIComponent((_b = (_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b['cube_router_url']));
            }
        }))();
    }, [props.defaultPost, userInfo.done, locationDone]);
    useEffect(() => {
        if (window === null || window === void 0 ? void 0 : window.inEditor) {
            // 在画布中确保后端已更新数据
            setTimeout(() => {
                init();
            }, 2000);
        }
    }, [tagIds]);
    // const onCityChange = useCallback(
    //   (city: { value: string; title: string }) => {
    //     console.log('民宿poi列表，监听到城市变化', city);
    //     if (city?.value) {
    //       console.log('民宿poi列表，监听到城市变化', city);
    //       chosenCityId.current = Number(city.value);
    //       isCityInitialized.current = true;
    //       if (userInfo.done) {
    //         setTimeout(() => {
    //           init();
    //         }, 0);
    //       }
    //     }
    //   },
    //   [userInfo.done],
    // );
    const onCityChange = (city) => {
        console.log('民宿poi列表，监听到城市变化', city);
        if (city === null || city === void 0 ? void 0 : city.value) {
            chosenCityId.current = Number(city.value);
            isCityInitialized.current = true;
            setTimeout(() => {
                init();
            }, 0);
        }
    };
    useEffect(() => {
        var _a;
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', onCityChange);
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged', onCityChange);
        };
    }, []);
    const onComponentShowMV = () => {
        var _a, _b, _c, _d, _e, _f;
        _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mvReport(LX_CONFIG.COMP_MV_BID, {
            valLab: {
                _moduleId: _moduleId !== null && _moduleId !== void 0 ? _moduleId : '-999',
                tex_id: (_c = (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) === null || _b === void 0 ? void 0 : _b.pageId) !== null && _c !== void 0 ? _c : '-999',
                custom: {
                    click_biz_line: clickBizLine !== null && clickBizLine !== void 0 ? clickBizLine : '-999',
                    hotel_channel: (_f = (_e = (_d = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _d === void 0 ? void 0 : _d.queryParams) === null || _e === void 0 ? void 0 : _e.hotelchannel) !== null && _f !== void 0 ? _f : '-999',
                    wakeupSource
                }
            }
        });
    };
    const jumpToNoDataFallbackPage = () => {
        if (window === null || window === void 0 ? void 0 : window.inEditor) {
            return;
        }
        onGoFilter({
            cityId: chosenCityId.current,
            clickBizLine,
            hotelchannel
        });
    };
    if (showSkeleton) {
        return <Skeleton showType={showType}/>;
    }
    if (showNoDataView) {
        return <View style={{
                backgroundColor: noDataBackgroundColor
            }} className="phx-poi-lis-no-data-container" onClick={() => {
                jumpToNoDataFallbackPage();
            }}>
        <Text style={{
                color: noDataTextColor
            }} className="phx-poi-lis-no-data-text">
          {noDataText}
        </Text>
        <Image style={{
                width: '750rpx'
            }} source={{
                uri: noDataImg
            }}/>
      </View>;
    }
    return <Sensor once onAppear={() => {
            onComponentShowMV();
        }}>
      <View className="phx-poi-lis-container" style={{
            marginTop,
            marginBottom,
            paddingLeft: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx',
            paddingRight: showType === SHOW_TYPE_ENUM.SIGNAL_ROW ? '12rpx' : '24rpx'
        }}>
        <View x-if={showType === SHOW_TYPE_ENUM.TWO_LIST}>
          <View className="phx-poi-lis-card-wrap">
            {(displayList !== null && displayList !== void 0 ? displayList : []).map((item, index) => {
            var _a, _b;
            return <Card poiInfo={Object.assign({}, item)} style={{
                    marginTop: index < 2 ? 0 : '18rpx'
                }} key={(_b = (_a = item.productId) !== null && _a !== void 0 ? _a : item.productIdStr) !== null && _b !== void 0 ? _b : index} clickBizLine={clickBizLine} wakeupSource={wakeupSource}/>;
        })}
          </View>
          <LoadingView x-if={showLoading} level={'medium'} showContent={false} style={{
            marginTop: '20rpx'
        }}/>
          <View x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.BUTTON || loadMoreType === LOAD_MORE_TYPE.LINK} className="phx-poi-lis-show-more-container" onClick={() => loadMore()}>
            <View className="phx-poi-lis-show-more-button">
              <Text className="phx-poi-lis-show-more-text">查看更多</Text>
              <Icon name="jiantouxianxia" color="#555555"/>
            </View>
          </View>
          <Sensor x-if={!noMore && loadMoreType === LOAD_MORE_TYPE.PULL_UP} className="phx-poi-lis-load-more-sensor" onAppear={() => {
            loadMore();
        }}/>
        </View>
        <View x-elseif={showType === SHOW_TYPE_ENUM.SIGNAL_ROW}>
          <ScrollView horizontal={true} showsHorizontalScrollIndicator={false}>
            {((_g = phxList.current) !== null && _g !== void 0 ? _g : []).slice(0, 10).map((item, index) => {
            var _a, _b;
            return <Card poiInfo={Object.assign({}, item)} style={{
                    marginRight: '18rpx'
                }} showType={SHOW_TYPE_ENUM.SIGNAL_ROW} key={(_b = (_a = item.productId) !== null && _a !== void 0 ? _a : item.productIdStr) !== null && _b !== void 0 ? _b : index} clickBizLine={clickBizLine} wakeupSource={wakeupSource}/>;
        })}
            <View className="phx-poi-lis-row-type-show-more-button" onClick={() => loadMore(LOAD_MORE_TYPE.LINK)}>
              <View className="phx-poi-lis-row-type-show-more-view">
                {'点击查看更多'.split('').map((char, index) => <Text key={char} className="phx-poi-lis-row-type-show-more-text" style={{
                color: 'white',
                height: '32rpx',
                fontFamily: 'PingFang SC',
                fontWeight: '400',
                fontSize: '24rpx',
                letterSpacing: 0
            }}>
                    {char}
                  </Text>)}
              </View>
            </View>
          </ScrollView>
        </View>
      </View>
    </Sensor>;
};
export function _customPVReportParams(params) {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function* () {
        const custom = {
            tex_id: ((_a = params === null || params === void 0 ? void 0 : params.queryParams) === null || _a === void 0 ? void 0 : _a['pageId']) || '-999',
            hotel_channel: ((_b = params === null || params === void 0 ? void 0 : params.queryParams) === null || _b === void 0 ? void 0 : _b['hotelchannel']) || '-999'
        };
        if ((_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.href) {
            custom.url = window.location.href;
        }
        return {
            custom: custom
        };
    });
}
export default memo(PhxPoiList);
